export function exportToCSV(content, fileName) {
  let a = document.createElement('a');
  let mimeType = 'text/csv;encoding:utf-8';

  if (navigator.msSaveBlob) { // IE10
    navigator.msSaveBlob(new Blob([content], {
      type: mimeType
    }), fileName);
  } else if (URL && 'download' in a) { //html5 A[download]
    a.href = URL.createObjectURL(new Blob([content], {
      type: mimeType
    }));
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
  }
}

export function exportToPDF(data, content, fileName, pageSize, pageOrientation) {
  let pdf = new shield.exp.PDFDocument({
    author: "Asianconnect88",
    created: new Date()
  });

  pdf.addPage(pageSize, pageOrientation);
  pdf.table(
    50,
    50,
    data,
    content,
    {
      margins: {
        top: 50,
        left: 50
      }
    }
  );

  pdf.saveAs({
    fileName: fileName
  });
}


// WEBPACK FOOTER //
// ./client/app/shared/utils/export.utils.js